import { render, staticRenderFns } from "./privacy-select.vue?vue&type=template&id=a7356e90&scoped=true"
import script from "./privacy-select.vue?vue&type=script&lang=js"
export * from "./privacy-select.vue?vue&type=script&lang=js"
import style0 from "./privacy-select.vue?vue&type=style&index=0&id=a7356e90&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7356e90",
  null
  
)

export default component.exports